function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 240,
  r: 240,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M413.332 74h-44.615c-26.479 0-49.238 10.625-68.278 31.874L246.427 172h98.441l16.957-20.643c3.287-3.762 7.334-5.647 12.149-5.647h86.795a236.19 236.19 0 00-3.128-7h-83.667c-6.927 0-12.865 2.828-17.42 8.042l-.07.08L341.559 165h-80.376l44.574-54.572C323.562 90.611 344.443 81 368.717 81h51.061a240.48 240.48 0 00-6.446-7zM66.667 406h45.017c26.479 0 49.239-10.732 68.278-32.205L233.888 308h-98.686l-16.626 20.303c-3.508 3.771-7.554 5.648-12.149 5.648H19.086a238.894 238.894 0 003.114 7h84.227c6.778 0 12.614-2.87 17.274-7.88l.151-.162L138.518 315H219.1l-44.464 54.252C156.819 389.299 135.94 399 111.684 399H60.221a240.688 240.688 0 006.446 7zm394.243-72.04h-86.936c-4.603 0-8.535-1.77-11.822-5.317L345.245 308h-98.397l53.918 65.795C319.585 395.268 342.238 406 368.717 406h44.615a239.704 239.704 0 006.446-7h-51.061c-24.257 0-45.021-9.701-62.611-29.732L261.634 315h80.296l14.942 18.244.145.156c4.535 4.895 10.294 7.56 16.957 7.56h83.821a239.708 239.708 0 003.115-7zM19.23 145.71h87.197c4.816 0 8.862 1.885 12.149 5.647L135.439 172h41.187l28.614-34.922-25.278-30.873C160.923 84.741 138.269 74 112.011 74H66.667a241.47 241.47 0 00-6.446 7h51.79c24.015 0 44.794 9.694 62.624 29.748l21.557 26.328L173.312 165H138.76l-14.836-18.161-.077-.087c-4.554-5.214-10.493-8.042-17.42-8.042H22.358a238.014 238.014 0 00-3.127 7z",
  fill: "#00D1FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M127.08 256.488h47.328V273h-71.904v-68.16h71.232v16.512H127.08v9.696h45.024v15.168H127.08v10.272zm93.874-16.512c0 5.184 1.376 9.216 4.128 12.096 2.816 2.88 6.944 4.32 12.384 4.32 5.12 0 9.12-1.472 12-4.416 2.944-2.944 4.416-6.944 4.416-12V204.84h24.576v38.112c0 6.592-1.6 12.32-4.8 17.184-3.136 4.864-7.776 8.608-13.92 11.232-6.144 2.624-13.568 3.936-22.272 3.936-8.704 0-16.128-1.312-22.272-3.936-6.144-2.688-10.816-6.496-14.016-11.424-3.2-4.928-4.8-10.688-4.8-17.28V204.84h24.576v35.136zm120.68 10.752H327.33V273h-24.576v-68.16h47.712c10.816 0 18.56 2.144 23.232 6.432 4.736 4.224 7.104 9.536 7.104 15.936 0 4.288-1.152 8.32-3.456 12.096-2.24 3.712-5.824 6.56-10.752 8.544L383.106 273h-27.072l-14.4-22.272zM327.33 236.04h17.28c3.648 0 6.272-.704 7.872-2.112 1.6-1.472 2.4-3.424 2.4-5.856 0-2.304-.8-4.128-2.4-5.472-1.6-1.408-4.192-2.112-7.776-2.112H327.33v15.552z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 240,
  y1: 0,
  x2: 240,
  y2: 701.818,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08021E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F0777"
})));

var SvgSEur = function SvgSEur(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSEur, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sEUR.e51f537a.svg";
export { ForwardRef as ReactComponent };